import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PaymentResponseDto, SchoolBillDto, SchoolSubsClassDto, SchoolSubscTransportDto } from '../api/models';
import { ActivatedRoute } from '@angular/router';
import { ReceiptControllerService } from '../api/services';
import { toPng } from 'html-to-image';


@Component({
    selector: 'app-receipt',
    imports: [],
    templateUrl: './receipt.component.html',
    styleUrl: './receipt.component.css'
})
export class ReceiptComponent  implements OnInit{


  receipt?:PaymentResponseDto;
  reference?:string;
  status:string|null|undefined='';
  receiptType ='Reçu de paiement';
  transport?:SchoolSubscTransportDto;
  reliquat?:SchoolBillDto;
  classe?:SchoolSubsClassDto;
  taxes: [string, number][] = [];
  total:number=0;
  @ViewChild('receiptCard') receiptCard!: ElementRef<HTMLElement>;
  isCapturing = false;
  shareError: string | null = null;

  constructor(private activeRoute:ActivatedRoute,
              private receiptService:ReceiptControllerService
             
  ){}

  ngOnInit(): void {
    
     this.status = this.activeRoute.snapshot.queryParamMap.get('status');
      this.activeRoute.params.subscribe(par=>{
        this.reference = par['reference'];
       
        this.getDetailsReceipt();
      });
    
  }
 

  getDetailsReceipt(){
    this.receiptService.getPaymentDetails(
      this.reference!!
    ).subscribe({
      next:(resp)=>{
        this.receipt =resp;
        if(this.status =undefined){
          this.status=resp.status;
        }
        if(this.status?.toUpperCase() =='PENDING'&&resp.status !='PENDING'){
         this.status =resp.status;
        }
        if(this.status?.toUpperCase() =='PENDING'){
          setTimeout(()=>
            {
              this.getDetailsReceipt();
            },
            20000);
        }else {
          let fees = this.receipt?.fees?this.receipt.fees:0;
          this.total = this.receipt.amount+fees;
          if(this.receipt.taxes){
              this.taxes =Object.entries(this.receipt.taxes);
              }
          if(this.receipt.transactionType=='REDEVANCE_IMMO'){
            this.receiptType='Redevance immobiliere';
          }else if(this.receipt.transactionType=='TUTOR_OFFER_PAY'){
            this.receiptType='Paiement soutienn scolaire';
          }
          if(this.receipt?.subscription){
             this.transport =this.receipt.subscription.transports?.at(0);
             this.reliquat = this.receipt.subscription.reliquat;
             this.classe=this.receipt.subscription.classes?.at(0);
             this.receiptType='Reçu reinscription école';
             
          }else if(this.receipt.bill){
            this.receiptType="Reçu mensualité scolaire";
          }
        }
        
      },
      
    });
  }

  private buildShareText(): string {
    const parts = [
      `${this.receiptType}`,
      this.receipt?.reference ? `Réf: ${this.receipt.reference}` : '',
      this.receipt?.amount != null
        ? `Montant: ${this.receipt.amount} ${this.receipt.currencyCode ?? ''}`.trim()
        : '',
      this.receipt?.paymentDate ? `Date: ${this.receipt.paymentDate}` : '',
    ].filter(Boolean);
    return parts.join('\n');
  }

  private receiptFileName(): string {
    return `recu-${this.receipt?.reference ?? this.reference ?? 'paiement'}.png`;
  }

  private async captureReceiptBlob(): Promise<Blob> {
    if (!this.receiptCard?.nativeElement) {
      throw new Error('Reçu introuvable');
    }
    const dataUrl = await toPng(this.receiptCard.nativeElement, {
      cacheBust: true,
      pixelRatio: 2,
      backgroundColor: '#ffffff',
    });
    const res = await fetch(dataUrl);
    return await res.blob();
  }

  private downloadBlob(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
  }

  async downloadReceiptImage(): Promise<void> {
    this.shareError = null;
    this.isCapturing = true;
    try {
      const blob = await this.captureReceiptBlob();
      this.downloadBlob(blob, this.receiptFileName());
    } catch {
      this.shareError = "Impossible de générer l'image du reçu.";
    } finally {
      this.isCapturing = false;
    }
  }

  /** Native share sheet (mobile: shows WhatsApp, Telegram, etc. with the image). */
  async shareReceipt(): Promise<void> {
    this.shareError = null;
    this.isCapturing = true;
    try {
      const blob = await this.captureReceiptBlob();
      const file = new File([blob], this.receiptFileName(), { type: 'image/png' });
      const nav = navigator as Navigator & {
        canShare?: (data: ShareData & { files?: File[] }) => boolean;
        share?: (data: ShareData & { files?: File[] }) => Promise<void>;
      };
      const shareDataFiles = {
        files: [file],
        title: this.receiptType,
        text: this.buildShareText(),
      };
      if (nav.canShare?.(shareDataFiles) && nav.share) {
        await nav.share(shareDataFiles);
        return;
      }
      if (nav.share) {
        await nav.share({
          title: this.receiptType,
          text: this.buildShareText(),
          url: window.location.href,
        });
        return;
      }
      // Desktop fallback: download image so the user can attach it manually.
      this.downloadBlob(blob, this.receiptFileName());
      this.shareError = 'Partage non supporté sur ce navigateur : image téléchargée.';
    } catch (err) {
      // User cancelling the share sheet throws AbortError — don't show an error.
      if (err instanceof DOMException && err.name === 'AbortError') {
        return;
      }
      this.shareError = "Impossible de partager l'image du reçu.";
    } finally {
      this.isCapturing = false;
    }
  }

  /** Direct fallbacks for desktop where Web Share API is unavailable. */
  shareViaWhatsApp(): void {
    const text = `${this.buildShareText()}\n${window.location.href}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
  }

  shareViaTelegram(): void {
    window.open(
      `https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&text=${encodeURIComponent(this.buildShareText())}`,
      '_blank',
      'noopener'
    );
  }
}
